export class RegularExpressions {
    static PasswordPolicy = /^.{8,}$/;
    static Email = /.+@.+/; // Very relaxed email validation
}